// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/singleProduct';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  home,
  aboutUs,
  singleProduct,
});

window.abc = function () {

  let swiper;
  window.globals = {};
  const body = document.getElementsByTagName("body")[0];
  const lightboxImages = document.querySelectorAll("[lightbox-toggle] img");
  const lightboxImagesComments = document.querySelectorAll("[lightbox-toggleComments] img");
  const initLightbox = lightboxImages.length > 0;
  const initLightboxComments = lightboxImagesComments.length > 0;
  const destroySwiper = (swiper, timeout) => {
    setTimeout(() => {
      swiper && swiper.destroy();
    }, timeout);
  };

  const createLightboxSkeleton = () => {
    // Create skeleton for lightbox
    const lightbox = document.createElement("div");
    const lightboxContainer = document.createElement("div");
    const lightboxClose = document.createElement("div");
    const swiperContainer = document.createElement("div");
    const swiperWrapper = document.createElement("div");
    const swiperBtnNext = document.createElement("div");
    const swiperBtnPrev = document.createElement("div");
    const swiperPagination = document.createElement("div");

    // Add classes
    lightbox.classList.add("c-lightbox");
    lightboxContainer.classList.add("c-lightbox__container");
    lightboxClose.classList.add("c-lightbox__close");
    lightboxClose.setAttribute("tabindex", "0");
    lightboxClose.innerHTML = "x";
    swiperContainer.classList.add("swiper-container");
    swiperWrapper.classList.add("swiper-wrapper");
    swiperBtnNext.classList.add("swiper-button-next");
    swiperBtnPrev.classList.add("swiper-button-prev");
    swiperPagination.classList.add("swiper-pagination");

    // Append created divs
    lightboxContainer.appendChild(lightboxClose);
    swiperContainer.appendChild(swiperWrapper);
    swiperContainer.appendChild(swiperBtnNext);
    swiperContainer.appendChild(swiperBtnPrev);
    swiperContainer.appendChild(swiperPagination);
    lightboxContainer.appendChild(swiperContainer);
    lightbox.appendChild(lightboxContainer);
    body.appendChild(lightbox);

    // Set variables to reference the lightbox
    globals.lightboxRef = document.querySelector(".c-lightbox");
    globals.swiperWrapperRef = document.querySelector(
      ".c-lightbox .swiper-wrapper"
    );
  };

  if (initLightbox || initLightboxComments) {
    if (!document.body.classList.contains('c-lightbox')) {
      createLightboxSkeleton();
    }
  }

  if (initLightbox) {
    // The rest of the code will go here
    lightboxImages.forEach(function (el, index) {
      // Add click function to lightbox images
      el.addEventListener("click", imageClick, false);

      function imageClick() {
        // Clear swiper before trying to add to it
        globals.swiperWrapperRef.innerHTML = "";

        // Loop through images with lightbox data attr
        // Create html for lightbox carousel
        lightboxImages.forEach(function (img) {
          console.log(index);
          // Create clone of current image in loop
          const image = img.cloneNode(true);
          // Create divs
          const slide = document.createElement("div");
          const imageContainer = document.createElement("div");
          // Add classes
          slide.classList.add("swiper-slide");
          imageContainer.classList.add("c-lightbox__image");
          // Append images to the slides, then slides to swiper wrapper
          imageContainer.appendChild(image);
          slide.appendChild(imageContainer);
          globals.swiperWrapperRef.appendChild(slide);
        });

        // Init Swiper
        swiper = new Swiper(".c-lightbox .swiper-container", {
          initialSlide: index,
          loop: true,
          slidesPerView: 1,
          speed: 750,
          spaceBetween: 16,
          watchOverflow: true,
          pagination: {
            el: ".swiper-pagination",
            type: "fraction"
          },
          zoom: false,
          fadeEffect: {
            crossFade: false
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          mousewheel: {
            sensitivity: 1,
            forceToAxis: true,
            invert: true
          }
        });

        // Add the class to open the lightbox
        // Add overflow hidden to the body to prevent scrolling
        globals.lightboxRef.classList.add("open");
        body.classList.add("overflowHidden");
      }
    });
  }

  if (initLightboxComments) {
    // The rest of the code will go here
    lightboxImagesComments.forEach(function (el, index) {
      // Add click function to lightbox images
      el.addEventListener("click", imageClick, false);

      function imageClick() {
        // Clear swiper before trying to add to it
        globals.swiperWrapperRef.innerHTML = "";

        // Loop through images with lightbox data attr
        // Create html for lightbox carousel
        lightboxImagesComments.forEach(function (img) {
          console.log(index);
          // Create clone of current image in loop
          const image = img.cloneNode(true);
          // Create divs
          const slide = document.createElement("div");
          const imageContainer = document.createElement("div");
          // Add classes
          slide.classList.add("swiper-slide");
          imageContainer.classList.add("c-lightbox__image");
          // Append images to the slides, then slides to swiper wrapper
          imageContainer.appendChild(image);
          slide.appendChild(imageContainer);
          globals.swiperWrapperRef.appendChild(slide);
        });

        // Init Swiper
        swiper = new Swiper(".c-lightbox .swiper-container", {
          initialSlide: index,
          loop: true,
          slidesPerView: 1,
          speed: 750,
          spaceBetween: 16,
          watchOverflow: true,
          pagination: {
            el: ".swiper-pagination",
            type: "fraction"
          },
          zoom: false,
          fadeEffect: {
            crossFade: false
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          mousewheel: {
            sensitivity: 1,
            forceToAxis: true,
            invert: true
          }
        });

        // Add the class to open the lightbox
        // Add overflow hidden to the body to prevent scrolling
        globals.lightboxRef.classList.add("open");
        body.classList.add("overflowHidden");
      }
    });
  }

  // Close lightbox on click
  document.addEventListener(
    "click",
    ({ target }) => {
      if (target.matches(".c-lightbox__close")) {
        destroySwiper(swiper, 250);
        globals.lightboxRef.classList.remove("open");
        body.classList.remove("overflowHidden");
      }
    },
    false
  );

  // Close lightbox on escape key press
  document.addEventListener("keydown", ({ key }) => {
    if (key === "Escape") {
      destroySwiper(swiper, 250);
      globals.lightboxRef.classList.remove("open");
      body.classList.remove("overflowHidden");
    }
  });
}
setTimeout(window.parent.abc, 10);
// Load Events
jQuery(document).ready(() => routes.loadEvents());

let backToTopBtn = document.getElementById("btn-back-to-top");
var lastScrollTop = 0;

if(backToTopBtn != null) {
  window.addEventListener("scroll", function(){
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop || st == 0) {
       backToTopBtn.style.display = "none";
     } else if (st < lastScrollTop) {
       backToTopBtn.style.display = "block";
     }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
 }, false);
 
 backToTopBtn.addEventListener("click", backToTop);
 
 function backToTop() {
   document.body.scrollTop = 0;
   document.documentElement.scrollTop = 0;
 }
}

const showMobileFiltersPopScrollUp = () => {
  var lastScrollTop = 0;
  $(window).on('scroll', function() {
    var scrollPosition = $(this).scrollTop();
    var mobileFilterPop = $('.mobile-filter-pop');

    if (scrollPosition < lastScrollTop) {
      if (scrollPosition > 100) {
        mobileFilterPop.addClass('fixed');
      } else {
        mobileFilterPop.removeClass('fixed');
      }
    } else {
      mobileFilterPop.removeClass('fixed');
    }

    lastScrollTop = scrollPosition;
  });
}
showMobileFiltersPopScrollUp();

window.addEventListener('load', function() {
  const signInUrl = window.location.protocol + "//" + window.location.hostname + '/sign-in';
  const currentPage = window.location.href;
  
  if (currentPage.includes(signInUrl)) {
    sessionStorage.setItem('previousPage', currentPage);
  }

  const getCurrentUrl = new URL(window.location.href);
  const isHomePage = getCurrentUrl.pathname == '/';

  if (isHomePage) {
    sessionStorage.removeItem('previousPage');
  }

  const backButton = document.getElementById("backBtn");
  backButton && backButton.addEventListener("click", customHistoryBack);
});

function customHistoryBack() {
  const signInUrl = window.location.protocol + "//" + window.location.hostname + '/sign-in';
  const previousPage = sessionStorage.getItem('previousPage');

  if (previousPage && previousPage.includes(signInUrl)) {
    window.location.href = window.location.protocol + "//" + window.location.hostname;
  } else {
    history.back();
  }
}

if (document.body.classList.contains('client-login')) {
  const inputs = document.querySelectorAll('input, textarea');

  function setKeyboardOffset() {
      const keyboardOffset = 300; // Adjust based on the typical keyboard height
      document.documentElement.style.setProperty('--keyboard-offset', `${keyboardOffset}px`);
  }

  function resetBody() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      document.documentElement.style.setProperty('--keyboard-offset', '0px');
  }

  inputs.forEach(input => {
      input.addEventListener('focus', () => {
          document.body.dataset.scrollY = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${window.scrollY}px`;
          document.body.style.overflow = 'hidden';
          document.body.style.width = '100%';
          setKeyboardOffset();
          document.body.classList.add('keyboard-open');
      });

      input.addEventListener('blur', () => {
          resetBody();
          document.body.classList.remove('keyboard-open');
          window.scrollTo(0, 0);
      });
  });

  window.addEventListener('scroll', () => {
      if (document.body.classList.contains('keyboard-open')) {
          document.body.dataset.scrollY = window.scrollY;
      }
  });

  window.addEventListener('resize', () => {
      if (!document.activeElement || !['input', 'textarea'].includes(document.activeElement.tagName.toLowerCase())) {
          resetBody();
      }
  });
}


// WEBPACK FOOTER //
// ./scripts/main.js